export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as homeRegimesKey,
  initialState as homeRegimesInitialState,
  State as HomeRegimesState,
} from './reducer';

export {
  getData as homeRegimesGetData,
  getError as homeRegimesGetError,
  getLoading as homeRegimesGetLoading,
  mapData as homeRegimesMapData,
} from './selectors';
